import React from 'react';
import { PitchDeck } from './components/PitchDeck';
export function App() {
  return <div className="w-full h-screen overflow-hidden bg-black" data-id="element-0">
      <PitchDeck data-id="element-1" />
    </div>;
}